import React from 'react';
import { PawPrint } from 'lucide-react';
export function Header() {
  return <header className="w-full border-b border-stone-200 bg-stone-50/80 backdrop-blur-md sticky top-0 z-50" data-id="element-69">
      <div className="max-w-3xl mx-auto px-6 py-4 flex flex-col sm:flex-row items-center justify-between gap-2" data-id="element-70">
        <div className="flex items-center gap-2 text-brand-brown" data-id="element-71">
          <PawPrint className="w-6 h-6" data-id="element-72" />
          <span className="font-sans font-bold text-xl tracking-tight" data-id="element-73">
            Napftagebuch
          </span>
        </div>
        <span className="font-serif text-sm text-stone-500 italic" data-id="element-74">
          Ehrliche Geschichten aus dem Hundealltag
        </span>
      </div>
    </header>;
}